export default function AIConfig() {
  return (
    <div className="animate-fade-in">
      <div className="page-header">
        <h1 className="page-title">AI Config</h1>
        <p className="page-subtitle">
          Additional AI configuration options
        </p>
      </div>

      <div className="card bg-neutral-50 border-dashed">
        <div className="text-center py-8">
          <p className="text-sm text-neutral-500 mb-4">
            AI configuration options have been moved to their respective pages
          </p>
          <p className="text-xs text-neutral-400">
            Visit AI Stylist for chat settings or AI Visual Merchandiser for display instructions
          </p>
        </div>
      </div>
    </div>
  );
}
